export default {
    all: 'All documents',
    empty: 'No document matches your search.',
    minus: 'View less -',
    page: 'Reference Documents',
    plus: 'View more +',
    view: 'View the document'
}